enum LogLevel {
  Error = 'error',
  Info = 'info',
  Warning = 'warning',
}

export default LogLevel;
